import project_1 from './project_1.webp';
import project_2 from './project_2.webp';
import project_3 from './project_3.webp';
import project_4 from './project_4.webp';
import project_5 from './project_5.webp';
import project_6 from './project_6.webp';

export const projects = {
  project_1: project_1.src,
  project_2: project_2.src,
  project_3: project_3.src,
  project_4: project_4.src,
  project_5: project_5.src,
  project_6: project_6.src,
};
